import {Typography, TypographyProps} from '@mui/material';
import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface AppInfoTextProps extends Omit<TypographyProps, 'children'> {
    children: React.ReactNode;
}
export const AppInfoText: React.FC<AppInfoTextProps> = ({children = '', ...rest}) => {
    return (
        <Typography {...rest} variant="subtitle2" color="primary" display="flex" alignItems="center" gap={0.5}>
            <InfoOutlinedIcon color="primary" fontSize="small" sx={{mr: 0.5}} />
            {children || 'No information available'}
        </Typography>
    );
};
export default AppInfoText;
